
export default function useReveal() {
  // Observe elements with class "reveal"
  if (typeof window === 'undefined') return;

  const onLoad = () => {
    const els = document.querySelectorAll('.reveal');
    const io = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) e.target.classList.add('in-view');
        });
      },
      { threshold: 0.2 }
    );
    els.forEach(el => io.observe(el));
  };

  if (document.readyState === 'complete') onLoad();
  else window.addEventListener('DOMContentLoaded', onLoad);
}
